@if (links?.length > 0) {
  <sd-copyright
    [links]="links"
    [changeCountryLink]="changeCountryUrl"
    [changeCountryTitle]="changeCountryName"
    [themesConfig]="themesConfig"
    [brand]="activeBrand"
  />
}
